export function addBill(bill) {
  return { type: "ADD_BILL", bill };
}
export function removeBill(billId) {
  return { type: "REMOVE_BILL", billId };
}
export function setFAQ(payload) {
  return { type: "FAQ", payload };
}
export function setBillInfo(payload) {
  return { type: "BILL_INFO", payload };
}
export function setChartData(payload) {
  return { type: "CHART_INFO", payload };
}
export function setFirstVisit(payload) {
  return { type: "FIRST_VISIT", payload };
}

export const clearPersist = () => {
  return (dispatch) => {
    dispatch({
      type: "LOGIN",
      isLogin: false,
    });
    dispatch({
      type: "TOKEN",
      token: false,
    });
  };
};
